import React from 'react';
import { Section, FadeIn } from './ui/Section';
export function WhyItFails() {
  return <Section background="white" data-id="element-311">
      <FadeIn data-id="element-312">
        <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-12 text-center leading-tight" data-id="element-313">
          Por qué lo que ya intentaste no funcionó <br data-id="element-314" />
          <span className="text-[#7A5C6B] text-2xl md:text-3xl" data-id="element-315">
            (y no es tu culpa)
          </span>
        </h2>
      </FadeIn>

      <div className="grid gap-8 md:grid-cols-2" data-id="element-316">
        <FadeIn delay={0.2} data-id="element-317">
          <div className="h-full p-8 border border-[#E8D5DC] rounded-xl bg-[#FFF5F0]/80 backdrop-blur-sm" data-id="element-318">
            <h3 className="text-xl font-bold text-[#3D1F2E] mb-4 font-serif" data-id="element-319">
              Presupuestos rígidos
            </h3>
            <p className="text-[#7A5C6B]" data-id="element-320">
              Fallan por una razón: llegan tarde. El presupuesto vive en tu
              cabeza "racional". El impulso aparece en tu cuerpo cansado,
              ansioso, buscando dopamina.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-321">
          <div className="h-full p-8 border border-[#E8D5DC] rounded-xl bg-[#FFF5F0]/80 backdrop-blur-sm" data-id="element-322">
            <h3 className="text-xl font-bold text-[#3D1F2E] mb-4 font-serif" data-id="element-323">
              Apps de finanzas
            </h3>
            <p className="text-[#7A5C6B]" data-id="element-324">
              Fallan porque se vuelven otra tarea y, cuando hay culpa, lo
              primero que haces es evitarlas.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-325">
          <div className="h-full p-8 border border-[#E8D5DC] rounded-xl bg-[#FFF5F0]/80 backdrop-blur-sm" data-id="element-326">
            <h3 className="text-xl font-bold text-[#3D1F2E] mb-4 font-serif" data-id="element-327">
              Disciplina pura
            </h3>
            <p className="text-[#7A5C6B]" data-id="element-328">
              Falla porque no es infinita. Se gasta. Especialmente en días
              largos.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-329">
          <div className="h-full p-8 flex items-center justify-center text-center" data-id="element-330">
            <p className="text-xl font-serif italic text-[#C4467E]" data-id="element-331">
              Lo que necesitas no es "ser otra persona". Es instalar un sistema
              que funcione con tu vida real, no con tu vida ideal.
            </p>
          </div>
        </FadeIn>
      </div>
    </Section>;
}